import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AppLayout from "./layout/AppLayout";
import AuthLayout from "./layout/AuthLayout";
import SignIn from "./pages/AuthPages/SignIn";
import SignUp from "./pages/AuthPages/SignUp";
import ForgotPassword from "./pages/AuthPages/ForgotPassword";
import Blank from "./pages/Blank";
import Calendar from "./pages/Calendar";
import TaxiDashboard from "./pages/Dashboard/TaxiDashboard";
import TripIssues from "./pages/TripIssue/TripIssues";
import TripIssueForm from "./pages/TripIssue/TripIssueForm";
import RideReviews from "./pages/RideReview/RideReviews";
import RideReviewForm from "./pages/RideReview/RideReviewForm";
import Statements from "./pages/Statement/Statements";
import StatementForm from "./pages/Statement/StatementForm";
import FlashSales from "./pages/FlashSale/FlashSales";
import FlashSaleForm from "./pages/FlashSale/FlashSaleForm";
import Coupons from "./pages/Coupon/Coupons";
import CouponForm from "./pages/Coupon/CouponForm";
import MeetGreetCharges from "./pages/MeetGreetCharge/MeetGreetCharges";
import MeetGreetChargeForm from "./pages/MeetGreetCharge/MeetGreetChargeForm";
import MorePricingOptions from "./pages/MorePricingOptions/MorePricingOptions";
import NoticePeriods from "./pages/Availability/NoticePeriods";
import TripRange from "./pages/Availability/TripRange";
import OperatingHours from "./pages/Availability/OperatingHours";
import NumberOfVehicles from "./pages/Availability/NumberOfVehicles";
import RouteFixedFareList from "./pages/RouteFixedFare/RouteFixedFare";
import RouteFixedFareForm from "./pages/RouteFixedFare/RouteFixedFareForm";
import RouteFixedFareDetail from "./pages/RouteFixedFare/RouteFixedFareDetail";
import PriceChecker from "./pages/PriceChecker/PriceChecker";
import PerMilePrices from "./pages/PerMilePrice/PerMilePrices";
import FormElements from "./pages/Forms/FormElements";
import NotFound from "./pages/OtherPage/NotFound";
import BasicTables from "./pages/Tables/BasicTables";
import Alerts from "./pages/UiElements/Alerts";
import Avatars from "./pages/UiElements/Avatars";
import Badges from "./pages/UiElements/Badges";
import Buttons from "./pages/UiElements/Buttons";
import Images from "./pages/UiElements/Images";
import Videos from "./pages/UiElements/Videos";
import UserProfiles from "./pages/UserProfiles";
import PrivateRoute from "./routes/PrivateRoute";
import AllAdminUsers from "./pages/AdminUser/AdminUsers";
import AdminUsersForm from "./pages/AdminUser/AdminUserForm";
import AdminUserDetail from "./pages/AdminUser/AdminUserDetail";
import AllRole from "./pages/Role/Roles";
import RoleForm from "./pages/Role/RoleForm";
import UserRoleMapping from "./pages/UserRoleMapping/UserRoleMapping";
import UserRoleMappingForm from "./pages/UserRoleMapping/UserRoleMappingForm";
import AllPermission from "./pages/Permission/Permissions";
import RolePermissionMapping from "./pages/RolePermissionMapping/RolePermissionMapping";
import RolePermissionMappingForm from "./pages/RolePermissionMapping/RolePermissionMappingForm";
import AdminUserAddresses from "./pages/AdminUserAddress/AdminUserAddresses";
import AdminUserAddressForm from "./pages/AdminUserAddress/AdminUserAddressForm";
import VehicleTypes from "./pages/VehicleType/VehicleTypes";
import VehicleTypeForm from "./pages/VehicleType/VehicleTypeForm";
import VehicleTypeDetail from "./pages/VehicleType/VehicleTypeDetail";
import Luggages from "./pages/Luggage/Luggages";
import LuggageForm from "./pages/Luggage/LuggageForm";
import LuggageDetail from "./pages/Luggage/LuggageDetail";
import SpecialPrices from "./pages/SpecialPrice/SpecialPrices";
import SpecialPriceForm from "./pages/SpecialPrice/SpecialPriceForm";
import SpecialPriceDetail from "./pages/SpecialPrice/SpecialPriceDetail";
import VehicleTimePrices from "./pages/VehicleTimePrice/VehicleTimePrices";
import VehicleTimePriceForm from "./pages/VehicleTimePrice/VehicleTimePriceForm";
import VehicleTimePriceDetail from "./pages/VehicleTimePrice/VehicleTimePriceDetail";
import Zones from "./pages/Zone/Zones";
import ZoneForm from "./pages/Zone/ZoneForm";
import ZoneDetail from "./pages/Zone/ZoneDetail";
import ServicePauses from "./pages/ServicePause/ServicePauses";
import ServicePauseForm from "./pages/ServicePause/ServicePauseForm";
import ServicePauseDetail from "./pages/ServicePause/ServicePauseDetail";
import LocationPrices from "./pages/LocationCharge/LocationPrices";
import LocationCharges from "./pages/LocationCharge/LocationCharges";
import LocationChargeForm from "./pages/LocationCharge/LocationChargeForm";
import LocationChargeDetail from "./pages/LocationCharge/LocationChargeDetail";
import PostcodeAreaPrices from "./pages/PostcodeAreaPrice/PostcodeAreaPrices";
import DeadLegs from "./pages/DeadLeg/DeadLegs";
import DeadLegForm from "./pages/DeadLeg/DeadLegForm";
import DeadLegDetail from "./pages/DeadLeg/DeadLegDetail";
import BookingsList from "./pages/Bookings/BookingsList";
import BookingEdit from "./pages/Bookings/BookingEdit";
import BookingDetails from "./pages/Bookings/BookingDetails";
import BookingFormAuditLogs from "./pages/Bookings/BookingFormAuditLogs";
import BookingFormAnalytics from "./pages/Bookings/BookingFormAnalytics";
import { VehicleList, VehicleForm, VehicleDetail } from "./pages/Vehicle";
import { CustomerList, CustomerForm, CustomerDetail } from "./pages/Customer";
import { DriverList, DriverForm, DriverDetail } from "./pages/Driver";
import ManageSessions from "./pages/Sessions/ManageSessions";
import WebsitePages from "./pages/WebsitePage/WebsitePages";
import WebsitePageForm from "./pages/WebsitePage/WebsitePageForm";
import SeoRoutes from "./pages/SeoRoute/SeoRoutes";
import SeoRouteForm from "./pages/SeoRoute/SeoRouteForm";
import SeoPlaces from "./pages/SeoPlace/SeoPlaces";
import SeoPlaceForm from "./pages/SeoPlace/SeoPlaceForm";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route element={<AppLayout />}>
            {/* Overview */}
            <Route index path="/" element={<TaxiDashboard />} />

            {/* Operations */}
            <Route path="/bookings" element={<BookingsList />} />
            <Route path="/booking-form-audit" element={<BookingFormAuditLogs />} />
            <Route path="/booking-analytics" element={<BookingFormAnalytics />} />
            <Route path="/bookings/add" element={<BookingEdit />} />
            <Route path="/bookings/edit/:id" element={<BookingEdit />} />
            <Route path="/bookings/:id/view" element={<BookingDetails />} />
            <Route path="/drivers" element={<DriverList />} />
            <Route path="/drivers/add" element={<DriverForm />} />
            <Route path="/drivers/:id" element={<DriverForm />} />
            <Route path="/drivers/:id/view" element={<DriverDetail />} />
            <Route path="/trip-issues" element={<TripIssues />} />
            <Route path="/trip-issues/add" element={<TripIssueForm />} />
            <Route path="/trip-issues/edit/:id" element={<TripIssueForm />} />
            <Route path="/ride-reviews" element={<RideReviews />} />
            <Route path="/ride-reviews/add" element={<RideReviewForm />} />
            <Route path="/ride-reviews/edit/:id" element={<RideReviewForm />} />
            <Route path="/statements" element={<Statements />} />
            <Route path="/statements/add" element={<StatementForm />} />
            <Route path="/statements/edit/:id" element={<StatementForm />} />

            {/* Promotions */}
            <Route path="/service-pauses" element={<ServicePauses />} />
            <Route path="/service-pauses/add" element={<ServicePauseForm />} />
            <Route path="/service-pauses/edit/:id" element={<ServicePauseForm />} />
            <Route path="/service-pauses/detail/:id" element={<ServicePauseDetail />} />
            <Route path="/price-checker" element={<PriceChecker />} />
            <Route path="/flash-sales" element={<FlashSales />} />
            <Route path="/flash-sales/add" element={<FlashSaleForm />} />
            <Route path="/flash-sales/edit/:id" element={<FlashSaleForm />} />
            <Route path="/coupons" element={<Coupons />} />
            <Route path="/coupons/add" element={<CouponForm />} />
            <Route path="/coupons/edit/:id" element={<CouponForm />} />
            <Route path="/dead-legs" element={<DeadLegs />} />
            <Route path="/dead-legs/add" element={<DeadLegForm />} />
            <Route path="/dead-legs/edit/:id" element={<DeadLegForm />} />
            <Route path="/dead-legs/detail/:id" element={<DeadLegDetail />} />
            <Route path="/route-fixed-fares" element={<RouteFixedFareList />} />
            <Route path="/route-fixed-fares/add" element={<RouteFixedFareForm />} />
            <Route path="/route-fixed-fares/edit/:id" element={<RouteFixedFareForm />} />
            <Route path="/route-fixed-fares/detail/:id" element={<RouteFixedFareDetail />} />

            {/* Pricing */}
            <Route path="/per-mile-prices" element={<PerMilePrices />} />
            <Route path="/zones" element={<Zones />} />
            <Route path="/zones/add" element={<ZoneForm />} />
            <Route path="/zones/edit/:id" element={<ZoneForm />} />
            <Route path="/zones/detail/:id" element={<ZoneDetail />} />
            <Route path="/location-charges" element={<LocationCharges />} />
            <Route path="/location-charges/add" element={<LocationChargeForm />} />
            <Route path="/location-charges/edit/:id" element={<LocationChargeForm />} />
            <Route path="/location-charges/detail/:id" element={<LocationChargeDetail />} />
            <Route path="/location-prices" element={<LocationPrices />} />
            <Route path="/postcode-area-prices" element={<PostcodeAreaPrices />} />
            <Route path="/meet-greet-charges" element={<MeetGreetCharges />} />
            <Route path="/meet-greet-charges/add" element={<MeetGreetChargeForm />} />
            <Route path="/meet-greet-charges/edit/:id" element={<MeetGreetChargeForm />} />
            <Route path="/vehicle-time-prices" element={<VehicleTimePrices />} />
            <Route path="/vehicle-time-prices/add" element={<VehicleTimePriceForm />} />
            <Route path="/vehicle-time-prices/:id" element={<VehicleTimePriceForm />} />
            <Route path="/vehicle-time-prices/:id/view" element={<VehicleTimePriceDetail />} />
            <Route path="/special-prices" element={<SpecialPrices />} />
            <Route path="/special-prices/add" element={<SpecialPriceForm />} />
            <Route path="/special-prices/edit/:id" element={<SpecialPriceForm />} />
            <Route path="/special-prices/detail/:id" element={<SpecialPriceDetail />} />
            <Route path="/luggage" element={<Luggages />} />
            <Route path="/luggage/add" element={<LuggageForm />} />
            <Route path="/luggage/edit/:id" element={<LuggageForm />} />
            <Route path="/luggage/detail/:id" element={<LuggageDetail />} />
            <Route path="/more-pricing-options" element={<MorePricingOptions />} />

            {/* Availability */}
            <Route path="/number-of-vehicles" element={<NumberOfVehicles />} />
            <Route path="/notice-periods" element={<NoticePeriods />} />
            <Route path="/trip-range" element={<TripRange />} />
            <Route path="/operating-hours" element={<OperatingHours />} />

            {/* Fleet & Customers */}
            <Route path="/vehicle-type" element={<VehicleTypes />} />
            <Route path="/vehicle-type/add" element={<VehicleTypeForm />} />
            <Route path="/vehicle-type/edit/:id" element={<VehicleTypeForm />} />
            <Route path="/vehicle-type/detail/:id" element={<VehicleTypeDetail />} />
            <Route path="/vehicles" element={<VehicleList />} />
            <Route path="/vehicles/add" element={<VehicleForm />} />
            <Route path="/vehicles/:id" element={<VehicleForm />} />
            <Route path="/vehicles/:id/view" element={<VehicleDetail />} />
            <Route path="/customers" element={<CustomerList />} />
            <Route path="/customers/add" element={<CustomerForm />} />
            <Route path="/customers/:id" element={<CustomerForm />} />
            <Route path="/customers/:id/view" element={<CustomerDetail />} />

            {/* Administration */}
            <Route path="/website-pages" element={<WebsitePages />} />
            <Route path="/website-pages/add" element={<WebsitePageForm />} />
            <Route path="/website-pages/edit/:id" element={<WebsitePageForm />} />
            <Route path="/seo-routes" element={<SeoRoutes />} />
            <Route path="/seo-routes/edit/:id" element={<SeoRouteForm />} />
            <Route path="/seo-places" element={<SeoPlaces />} />
            <Route path="/seo-places/edit/:id" element={<SeoPlaceForm />} />
            <Route path="/admin-user" element={<AllAdminUsers />} />
            <Route path="/admin-user/add" element={<AdminUsersForm />} />
            <Route path="/admin-user/edit/:id" element={<AdminUsersForm />} />
            <Route path="/admin-user/detail/:id" element={<AdminUserDetail />} />
            <Route path="/manage-sessions" element={<ManageSessions />} />
            <Route path="/role" element={<AllRole />} />
            <Route path="/role/add" element={<RoleForm />} />
            <Route path="/role/edit/:roleId" element={<RoleForm />} />
            <Route path="/permission" element={<AllPermission />} />
            <Route path="/user-role-mapping" element={<UserRoleMapping />} />
            <Route path="/user-role-mapping/add" element={<UserRoleMappingForm />} />
            <Route path="/user-role-mapping/edit/:mappingId" element={<UserRoleMappingForm />} />
            <Route path="/role-permission-mapping" element={<RolePermissionMapping />} />
            <Route path="/role-permission-mapping/add" element={<RolePermissionMappingForm />} />
            <Route path="/role-permission-mapping/edit/:mappingId" element={<RolePermissionMappingForm />} />
            <Route path="/admin-user-address" element={<AdminUserAddresses />} />
            <Route path="/admin-user-address/add" element={<AdminUserAddressForm />} />
            <Route path="/admin-user-address/edit/:addressId" element={<AdminUserAddressForm />} />

            {/* Account & template pages (not in sidebar) */}
            <Route path="/profile" element={<UserProfiles />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/blank" element={<Blank />} />
            <Route path="/form-elements" element={<FormElements />} />
            <Route path="/basic-tables" element={<BasicTables />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/avatars" element={<Avatars />} />
            <Route path="/badges" element={<Badges />} />
            <Route path="/buttons" element={<Buttons />} />
            <Route path="/images" element={<Images />} />
            <Route path="/videos" element={<Videos />} />
          </Route>
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
